import mixpanel from "mixpanel-browser";
import { useCallback } from "react";
import { MktVersionTypes } from "components/mkt/mktVersionUtils";

export default function useMixpanelMKT(request: {
  params?: { [key: string]: string };
  eventName: string;
  version: MktVersionTypes;
}) {
  let params: { [p: string]: string };
  params = request.params ? request.params : {};

  return useCallback(async () => {
    try {
      const instance = (mixpanel as any).promotion;
      if (instance) {
        instance.track(request.eventName, params);
      } else {
        console.warn("Mixpanel promotion instance not initialized");
      }
    } catch (error) {
      console.error("error", error);
    }
  }, [request.eventName, params]);
}
